import { createAction, props } from '@ngrx/store';
import { ProfileInfoDto } from '../../interfaces/profile/profile';

// Load profile actions
export const loadProfile = createAction('[Profile] Load Profile');

export const loadProfileSuccess = createAction('[Profile] Load Profile Success', props<{ profile: ProfileInfoDto }>());

export const loadProfileFailure = createAction('[Profile] Load Profile Failure', props<{ error: string }>());

// Clear profile (on logout)
export const clearProfile = createAction('[Profile] Clear Profile');
